module.exports = __webpack_public_path__ + "img/a679fb0.jpg";